<template>
  <div>
    <label :for="id" class="sr-only">{{ label }}</label>
    <div class="relative">
      <input
        :id="id"
        :name="name"
        :type="inputType"
        :value="modelValue"
        @input="handleInput"
        @blur="$emit('blur', $event)"
        :required="required"
        class="appearance-none relative block w-full px-3 py-2 md:py-3 border border-gray-700 placeholder-gray-500 text-white rounded-lg bg-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent text-sm md:text-base"
        :placeholder="placeholder"
        :class="{ 'border-red-500': error }"
      />
      <button
        v-if="type === 'password'"
        @click.prevent="togglePasswordVisibility"
        type="button"
        class="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 cursor-pointer"
      >
        <svg
          v-if="!isPasswordVisible"
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          />
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
          />
        </svg>
        <svg
          v-else
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
          />
        </svg>
      </button>
    </div>
    <p v-if="error" class="mt-1 text-xs text-red-500">{{ error }}</p>
  </div>
</template>

<script>
export default {
  name: 'FormInput',
  props: {
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'text',
    },
    label: {
      type: String,
      required: true,
    },
    modelValue: {
      type: [String, Number],
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
    },
    // Nova prop za kontrolu uklanjanja razmaka
    noSpaces: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue', 'blur', 'input'],
  data() {
    return {
      isPasswordVisible: false,
    };
  },
  computed: {
    inputType() {
      if (this.type === 'password' && this.isPasswordVisible) {
        return 'text';
      }
      return this.type;
    },
  },
  methods: {
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },

    handleInput(event) {
      let value = event.target.value;

      // Ako je noSpaces prop true ili ako je to jedno od polja koje automatski tretiramo
      const shouldRemoveSpaces = this.noSpaces || this.shouldAutoRemoveSpaces();

      if (shouldRemoveSpaces) {
        // Uklanjamo sve razmake
        value = value.replace(/\s/g, '');

        // Ažuriramo vrednost u input polju da korisnik vidi promenu
        event.target.value = value;
      }

      // Emitujemo oba eventi
      this.$emit('update:modelValue', value);
      this.$emit('input', event);
    },

    // Automatski uklanja razmake za specifična polja na osnovu name atributa
    shouldAutoRemoveSpaces() {
      const fieldsToClean = [
        'username',
        'email',
        'password',
        'confirm-password',
        'firstName',
        'lastName',
      ];

      return fieldsToClean.includes(this.name);
    },
  },
};
</script>
